import { API, graphqlOperation } from "aws-amplify";
import { MstGraphType, MstGraphTitlesType } from "../types/types";
import GraphContent from "../../src/components/graphContent/graph_content";
import MakeInputBody from "./lib/make_input_body";

const parseKeys = ["alertHistory", "range", "threshold", "unconfirmedAlert"];

const mstGraphItems = `user_id,
graph_id,
alertHistory,
attributes,
authStoreName,
drawRange,
graphDateFormat,
graphTitle,
lineType,
mails,
partitionKey,
partitionKeyType,
sortKey,
sortKeyType,
partitions,
range,
table,
targetAttribute,
targetAttributes,
targetPartitionKey,
threshold,
thresholdSettings,
timeFormat,
orgTimeFormat,
dataTimezone,
unconfirmedAlert,
updateInterval
changeAlertSwitch
thresholdSettingsList`;

export default class MstGraphService {
  /**
   * グラフマスター取得
   * @param userID
   * @param graphID
   */
  public static async query(userID: string, graphID: number) {
    const queryBody = `
      query getMstGraph {
        queryIotKyotoMstGraph(user_id: "${userID}", graph_id: ${graphID}) {
          items {
            ${mstGraphItems}
          }
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(queryBody));
    const items: MstGraphType = result.data.queryIotKyotoMstGraph.items[0];
    if (typeof items === "undefined") {
      return null;
    } else {
      return MstGraphService.parseItems(items);
    }
  }

  public static async queryAll(userID: string) {
    const queryAllBody = `
      query getAllMstGraph {
        queryAllIotKyotoMstGraph(user_id: "${userID}") {
          items {
            user_id,
            graph_id,
            graphTitle,
            attributes
          }
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(queryAllBody));
    const mstGraphTitles: MstGraphTitlesType[] =
      result.data.queryAllIotKyotoMstGraph.items;
    return mstGraphTitles;
  }

  /**
   * グラフマスター作成
   * @param newMstGraphData
   */
  public static async create(newMstGraphData: MstGraphType) {
    const createBody = `
      mutation create {
        createIotKyotoMstGraph(
          input: {
            ${MakeInputBody.make(newMstGraphData)}
          }
        ) {
          ${mstGraphItems}
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(createBody));
    const items: MstGraphType = result.data.createIotKyotoMstGraph;
    return MstGraphService.parseItems(items);
  }

  /**
   * グラフマスター更新
   * @param updateMstGraphData
   */
  public static async update(updateMstGraphData: MstGraphType) {
    const updateBody = `
      mutation update {
        updateIotKyotoMstGraph(
          input: {
            ${MakeInputBody.make(updateMstGraphData)}
          }
        ) {
          ${mstGraphItems}
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(updateBody));
    const items: MstGraphType = result.data.updateIotKyotoMstGraph;
    return MstGraphService.parseItems(items);
  }

  /**
   * グラフマスター削除
   * @param userID
   * @param graphID
   */
  public static async delete(userID: string, graphID: string) {
    const deleteBody = `
      mutation delete {
        deleteIotKyotoMstGraph(
          input: {
            user_id: "${userID}"
            graph_id: ${graphID}
          }
        ) {
          user_id
          graph_id
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(deleteBody));
    return result;
  }

  public static async getData(self: GraphContent, userID: string) {
    const inputBody = `
      mutation getData {
        getDataFunction(
          input: {
            user_id: "${userID}"
            graph_id: ${self.graphID}
            mst_graph: {
              ${MakeInputBody.make(self.mst_graph)}
            }
            auth_store: {
              user_id: "${self.auth_store.user_id}"
              store_name: "${self.auth_store.store_name}"
              accessKey: "${self.auth_store.accessKey}"
              secretKey: "${self.auth_store.secretKey}"
              region: "${self.auth_store.region}"
            }
          }
        )
      }
    `;
    const result: any = await API.graphql(graphqlOperation(inputBody));
    return JSON.parse(result.data.getDataFunction);
  }

  private static parseItems(items: MstGraphType) {
    Object.keys(items).map((key: string) => {
      if (parseKeys.indexOf(key) >= 0) {
        items[key] = JSON.parse(items[key]);
      }
    });
    return items;
  }
}
